module.exports = __webpack_public_path__ + "static/media/logo_small.e3e8d228.png";